




















































import { ZenyaDialogComponent, ZenyaDialogInjects } from "../../dialogs/ZenyaDialog.vue";
import QuillEditor from "../../../components/generic/QuillEditor.vue";
import UserSelector from "../../generic/UserSelector/UserSelector.vue";
import storeHelper from "@/store/store-helper";
import { Controllers } from "@infoland/iprova-api";
import { Constants } from "@/constants";
import { QuillEditorContent } from "@/types/quillEditorContent";
import { SnackBarTimeout } from "@/enums";
import { UserItem } from "@/components/generic/UserSelector/types";

export const selectionTypes = {
    user: "user"
};
export const emailQuillEditorToolbarOptions = [
    Constants.QuillEditorOptions.textFormatOptions,
    Constants.QuillEditorOptions.listOptions,
    Constants.QuillEditorOptions.indentOptions
];

export default ZenyaDialogComponent.extend({
    inject: ZenyaDialogInjects,
    name: "EmailDocument",
    props: {
        documentProperties: Object // strong typing throws error
    },
    components: {
        QuillEditor,
        UserSelector
    },
    data() {
        return {
            userEmails: [] as UserItem[],
            emailSubjectText: this.documentProperties.title as string,
            emailMessage: {} as QuillEditorContent,
            selectionTypes: [selectionTypes.user],
            documentHyperlink: "",
            isEmailMessageMissing: false,
            copyToMyself: false,
            quillEditorToolbarOptions: emailQuillEditorToolbarOptions
        };
    },
    created() {
        this.registerHandlers({ ok: this.oKClicked, cancel: this.cancelClicked });
        this.initData();
    },
    computed: {
        requiredRule() {
            return [(v: string) => Boolean(v.trim()) || this.$t("general.validation.isRequired")];
        }
    },
    methods: {
        initData() {
            this.documentHyperlink = location.href.replace(location.hash, "#/document/" + this.documentProperties.document_id);
            this.emailSubjectText = this.documentProperties.title;
            this.emailMessage.content = `<p><label><a href=${this.documentHyperlink}>${this.documentProperties.title}</a></label></p>`;
        },
        async oKClicked(): Promise<boolean> {
            if (this.validateForm()) {
                let userIds: string[] = this.userEmails.map(ue => ue.assigneeId);
                if (this.copyToMyself) {
                    userIds.push(this.$user.user_id);
                }

                const emailWasSent = await Controllers.DocumentsController.sendMailDocumentAsync(
                    this.documentProperties.document_id,
                    this.documentProperties.version,
                    this.emailSubjectText,
                    this.emailMessage.content,
                    userIds
                );
                if (emailWasSent) {
                    await storeHelper.siteStore.setSnackBarMessage(
                        this.$t("emailDocument.sendEmailSuccess").toString(),
                        false,
                        SnackBarTimeout.short
                    );
                    this.resetData();
                    return true;
                } else {
                    await storeHelper.siteStore.setSnackBarMessage(this.$t("emailDocument.sendEmailFailed").toString(), true, SnackBarTimeout.short);
                    return false;
                }
            }
        },
        cancelClicked(): Promise<boolean> {
            this.resetData();
            return new Promise((resolve, reject) => {
                resolve(true);
            });
        },
        getContentfromQuill(event) {
            this.emailMessage.content = event;
        },
        validateForm(): boolean {
            let formIsValid = (this.$refs.form as Vue & { validate: () => boolean }).validate();
            return formIsValid;
        },
        resetData(): any {
            this.initData();
            this.userEmails.splice(0);
            this.copyToMyself = false;
        }
    }
});
